import { Controller } from "@hotwired/stimulus";
import dbInstance from "./indexeddb";
class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.dbInstance = new dbInstance();
    }
    async connect() {
        try {
            await this.dbInstance.initDB();
        }
        catch (error) {
            console.error("Failed to initialize dbInstance:", error);
        }
    }
    async submit(event) {
        event.preventDefault();
        if (!this.hasFormTarget) {
            console.error("Form target not found");
            return;
        }
        try {
            // Get guest_id from dbInstance
            const guestId = await this.getGuestIdFromdbInstance();
            // Create FormData and add the guest_id if it exists
            const formData = new FormData(this.formTarget);
            if (guestId && typeof guestId === "string") {
                formData.append("guest_id", guestId);
            }
            else if (guestId) {
                // Convert to string if it's not null/undefined but not a string
                formData.append("guest_id", String(guestId));
            }
            else {
                console.warn("No existing guest_id found in dbInstance");
            }
            // Submit the form with the additional data
            const response = await fetch(this.formTarget.action, {
                method: "POST",
                body: formData,
                headers: {
                    "X-CSRF-Token": this.getCSRFToken(),
                    Accept: "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8",
                },
                redirect: "follow", // Important to allow redirects
            });
            if (response.ok) {
                window.location.href = response.url || "/";
            }
            else {
                console.error("Form submission failed:", response.statusText);
            }
        }
        catch (error) {
            this.formTarget.submit(); // Fallback to submit form normally
        }
    }
    async getGuestIdFromdbInstance() {
        try {
            if (!this.dbInstance || !this.dbInstance.db) {
                console.warn("dbInstance not initialized");
                return null;
            }
            const guestId = await this.dbInstance.getValue("config", "guest_id");
            if (guestId && typeof guestId === "string") {
                return guestId;
            }
            else if (guestId) {
                return String(guestId);
            }
            else {
                return null;
            }
        }
        catch (error) {
            console.error("Failed to retrieve guest_id from dbInstance:", error);
            return null;
        }
    }
    getCSRFToken() {
        // Use the CSRF token from dbInstance instance
        if (this.dbInstance && this.dbInstance.csrfToken) {
            return this.dbInstance.csrfToken;
        }
        // Fallback to getting it from meta tag
        const metaTag = document.querySelector('meta[name="csrf-token"]');
        return metaTag ? metaTag.getAttribute("content") || "" : "";
    }
}
default_1.targets = ["form"];
export default default_1;
